module.exports = __webpack_public_path__ + "static/media/lmm-logo-text.5ae92569.png";